import { AppStore } from "@/store/modules/AppStore";

export default function i18n(text:string):string {
  const locale = AppStore.user?.lang || 'en'
  const regex = new RegExp(`\\[${locale}:(([^/])*)\\/\\]`, 'g');
  const results = regex.exec(text);
  const localized = (results && results.length > 0) ? results[1] : text

  return localized
}